module.exports = __webpack_public_path__ + "img/sensor_1.a9914cc4.png";